import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { ChatMessageItem } from '../../graphql/API';
import { onAdminUpdateChatMessage } from '../../graphql/subscriptions';
import { GqlError, getError, getErrorFromResult, processGqlResult } from '../../utils/gql-utils';

const client = generateClient();

export const useOnAdminUpdateChatMessageListener = (
  messageTime?: string,
  conversationId?: string,
) => {
  const [message, setMessage] = React.useState<Nullable<ChatMessageItem>>(null);
  const [error, setErorr] = React.useState<GqlError>();

  React.useEffect(() => {
    if (messageTime && conversationId) {
      const createSub = client.graphql({
        query: onAdminUpdateChatMessage,
        variables: { messageTime, conversationId },
      }).subscribe({
        next: ({ data }: { data: { onAdminUpdateChatMessage: ChatMessageItem } }) => {
          const _message = processGqlResult<ChatMessageItem>('onAdminUpdateChatMessage', { data });
          setMessage(_message);
          const errorFromResponse = getErrorFromResult({ data });

          if (errorFromResponse) {
            throw errorFromResponse;
          }
        },
        error: (ex) => {
          const raisedError = getError(ex);
          console.error(raisedError);
          setErorr(raisedError);
        },
      });

      return () => {
        createSub.unsubscribe();
      };
    }
  }, [setMessage, conversationId, messageTime]);

  return {
    message,
    error,
  };
};
